import { CartItemModel, CartModel } from "../../models/cart";
import * as FetchUtil from "../fetch-util";

interface NagivationLinksResponse {
  redirectUrl: string;
}

export class CartService {
  static add(productIds: string[]): Promise<FetchUtil.HttpResponse<NagivationLinksResponse>> {
    return this.checkout(productIds);
  }
  static checkout(productIds: string[]): Promise<FetchUtil.HttpResponse<NagivationLinksResponse>> {
    return FetchUtil.post(`/api/v1/store/cart`, { productIds });
  }
  static addToCart(cartItem: CartItemModel): Promise<FetchUtil.HttpResponse<FetchUtil.ErrorResponse & CartModel>> {
    return FetchUtil.post(`/api/v1/store/cart`, cartItem);
  }
  static getCart(): Promise<FetchUtil.HttpResponse<FetchUtil.ErrorResponse & CartModel>> {
    return FetchUtil.get(`/api/v1/store/cart`);
  }
  static remove(productId: string): Promise<FetchUtil.HttpResponse<FetchUtil.ErrorResponse & CartModel>> {
    return FetchUtil.Delete(`/api/v1/store/cart/${productId}`, {});
  }
}
